import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
    'https://gksfdytuganuoitggevz.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdrc2ZkeXR1Z2FudW9pdGdnZXZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ0OTQyMDIsImV4cCI6MjA4MDA3MDIwMn0.aEJu0e-iuN6RrIhZPs5abXGAD-87w2zuQzhwru_dLGE',
);